// extracted by mini-css-extract-plugin
export default {"qr-image":"qrticket_qr-image__uy82u","qr-error-text":"qrticket_qr-error-text__X7Dsq"};